module.exports = __webpack_public_path__ + "img/npjiejue.35dfa8f3.png";